(()=>{const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initMotion(){
  if(reduced)return;
  document.documentElement.classList.add('jackal-motion-ready');
  const selectors=[
    '.jackal-new-arrivals .m-product-card',
    '.jackal-collection-crossnav .m-collection-card',
    '.jackal-values__item',
    '.jackal-categories .m-image-card',
    '.jackal-editorial-pdp__lead > *',
    '.jackal-editorial-pdp__secondary',
    '.jackal-faq__header',
    '.jackal-faq__item',
    '.jackal-contact-intro__copy',
    '.jackal-contact-intro__media'
  ];
  const nodes=[...document.querySelectorAll(selectors.join(','))];
  nodes.forEach((el,i)=>{el.dataset.jackalMotion='';el.style.setProperty('--jackal-delay',Math.min(i%6,5)*70+'ms')});
  const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-jackal-visible');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -40px'});
  nodes.forEach(n=>io.observe(n));
}
function initSizeDrawer(){
  const drawer=document.querySelector('[data-jackal-size-drawer]');
  if(!drawer)return;
  const openers=document.querySelectorAll('[data-jackal-size-open]');
  const closers=drawer.querySelectorAll('[data-jackal-size-close]');
  const unitBtns=drawer.querySelectorAll('[data-jackal-unit]');
  const tables=drawer.querySelectorAll('[data-jackal-size-table]');
  const open=()=>{drawer.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';drawer.querySelector('.jackal-size-drawer__close')?.focus()};
  const close=()=>{drawer.setAttribute('aria-hidden','true');document.documentElement.style.overflow=''};
  openers.forEach(b=>b.addEventListener('click',open));
  closers.forEach(b=>b.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer.getAttribute('aria-hidden')==='false')close()});
  unitBtns.forEach(btn=>btn.addEventListener('click',()=>{
    const unit=btn.dataset.jackalUnit;
    unitBtns.forEach(b=>b.classList.toggle('is-active',b===btn));
    tables.forEach(t=>t.hidden=t.dataset.jackalSizeTable!==unit);
  }));
}
function init(){initMotion();initSizeDrawer()}
document.addEventListener('DOMContentLoaded',init);
document.addEventListener('shopify:section:load',init);
})();